import {
  TableData,
  TableHeaderCategoryConfig,
} from "../../../../components/tables/tableContext/TableContext";
import { AwbHistoryDataInterface } from "../../../../redux/interfaces/general.interface";
import { getDateAndTime } from "../../../../utils/dateAndTime";

export const awbHistoryTableHeader: TableHeaderCategoryConfig[] = [
  {
    label: "Nr. expeditie",
    value: "doc_trans",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Pct. preluare",
    value: "pctpreluare",
    minW: 150,
  },
  {
    label: "Pct. livrare",
    value: "pctlivrare",
    minW: 170,
    withSearch: true,
  },
  {
    label: "Adresa",
    value: "adresa",
    minW: 125,
  },
  {
    label: "Facturi",
    value: "facturi",
    minW: 125,
    withSearch: true,
  },
  {
    label: "Nod-Destinatie",
    value: "nodDestinatie",
    minW: 125,
  },
  {
    label: "Status",
    value: "status",
    minW: 125,
  },
  {
    label: "Tipul expedierii",
    value: "tip_colete",
    minW: 125,
  },
  {
    label: "Nota",
    value: "observatii",
    minW: 125,
  },
  {
    label: "Data creare/ridicare",
    value: "data_crearii",
    minW: 125,
  },
];

export const getAwbTableData = (data: AwbHistoryDataInterface[]): TableData[] =>
  data.map((item) => {
    return {
      id: item.id_doctrans,
      crudData: item,
      data: [
        {
          title: item.doc_trans,
        },
        {
          title: item.pctpreluare,
        },
        {
          title: item.pctlivrare,
        },
        {
          title: item.adresa,
        },
        {
          title: item.facturi,
        },
        {
          title: item.nodDestinatie,
        },
        {
          badges: [
            {
              badgeText: item.denumireStatus,
              badgeColor: "light-info",
            },
          ],
        },
        {
          badges: item.tip_colete.map((tip) => {
            return {
              badgeText: `${tip.denumire} x ${tip.count_tip_ambalaj}`,
              badgeColor: "primary",
            };
          }),
        },

        {
          title: item.observatii ?? "-",
        },

        {
          badges: [
            {
              badgeText: item.data_crearii
                ? getDateAndTime(item.data_crearii)
                : "-",
              badgeColor: "light-info",
            },
            {
              badgeText: item.data_ridicare
                ? getDateAndTime(item.data_ridicare)
                : "-",
              badgeColor: "light-success",
            },
          ],
        },
      ],
    };
  });
